"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToButtonFragment = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _client = require("@apollo/client");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  fragment goToButtonFragment on Page {\n    id\n    goToButton {\n      isEnabled\n      icon {\n        ... on DefaultIcon {\n          icon\n        }\n\n        ... on Image {\n          id\n          scaledSrc {\n            w60\n          }\n        }\n      }\n      link {\n        group {\n          id\n        }\n        tracking {\n          name\n          category\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// definition
var goToButtonFragment = (0, _client.gql)(_templateObject());
exports.goToButtonFragment = goToButtonFragment;